import type { ObjectResponse } from '@/modules/core/interfaces/api-response.interfaces'
import Result from '@/modules/core/models/result.class'
import { starsaversApi } from '@/modules/core/services/api/starsavers-api.service.ts'
import { BaseApiService } from '@/modules/core/services/api/base-api.service.ts'

export default class UserApiService extends BaseApiService {
  async updateFmcToken(
    userType: string,
    regulatorCompanyId: number,
    employeeId: number,
    token: string
  ) {
    try {
      const dto = {
        fmc_token: token,
      }

      const url = ''
      const response = await starsaversApi.put<ObjectResponse<number>>(url, dto)

      if (response.status) {
        return Result.success(response.data!)
      } else {
        return Result.failure(new Error(response.message || 'An unknown error occurred'))
      }
    } catch (error) {
      return this.handleApiError(error)
    }
  }
}
